import { render, staticRenderFns } from "./DesignResponsibleList.vue?vue&type=template&id=edd966f8&"
import script from "./DesignResponsibleList.vue?vue&type=script&lang=js&"
export * from "./DesignResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./DesignResponsibleList.vue?vue&type=style&index=0&id=edd966f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports